var _circle, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatWithHuman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 58,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 64.2977C128 99.8083 99.3462 128.595 64 128.595C28.6538 128.595 0 99.8083 0 64.2977C0 28.7871 28.6538 0 64 0C99.3462 0 128 28.7871 128 64.2977ZM8.93073 64.2977C8.93073 94.8531 33.5861 119.623 64 119.623C94.4139 119.623 119.069 94.8531 119.069 64.2977C119.069 33.7423 94.4139 8.97227 64 8.97227C33.5861 8.97227 8.93073 33.7423 8.93073 64.2977Z",
    fill: "#304564"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1598_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1317 39.2123C50.1317 36.3336 52.5849 34 55.6111 34H73.2479C76.2741 34 78.7274 36.3336 78.7274 39.2123C78.7274 42.0909 76.2741 44.4246 73.2479 44.4246H55.6111C52.5849 44.4246 50.1317 42.0909 50.1317 39.2123Z",
    fill: "#304564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4262 48.5781C42.4262 43.9902 46.336 40.271 51.159 40.271H77.8711C82.6941 40.271 86.604 43.9902 86.604 48.5781V62.749L87.9772 77.3183C88.4354 82.1795 84.4101 86.3672 79.2793 86.3672H50.3382C45.338 86.3672 41.3587 82.3811 41.617 77.631L42.4262 62.749V48.5781Z",
    fill: "#304564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7624 74.8021C35.162 73.9328 35.9854 73.3022 36.9616 73.1075L40.4009 72.4215C40.6089 72.3801 40.8209 72.3591 41.0334 72.3591H87.8689C88.0525 72.3591 88.2358 72.3748 88.4165 72.4058L92.2703 73.0677C93.5033 73.2795 94.4942 74.1783 94.7232 75.35C95.1038 77.2978 95.1399 78.4811 94.5258 80.1279C94.3922 80.4861 94.3093 80.8617 94.3093 81.2418V92.0681C94.3093 93.6873 92.9293 95 91.2271 95H38.4877C36.7855 95 35.4056 93.6873 35.4056 92.0681V81.4934C35.4056 80.9525 35.2417 80.423 34.9614 79.9524C33.6202 77.7014 33.8052 76.8849 34.7624 74.8021Z",
    fill: "#304564"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9934 44.1129C73.9934 49.1459 69.8356 53.2259 64.7066 53.2259C59.5776 53.2259 55.4198 49.1459 55.4198 44.1129C55.4198 39.08 59.5776 35 64.7066 35C69.8356 35 73.9934 39.08 73.9934 44.1129Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0855 74.0709C51.0855 76.3033 49.7734 78.4804 47.4157 78.4804C45.058 78.4804 43 77.2587 43 75.0263C42.9973 73.0073 45.083 72.4118 47.4438 72.1601C49.8015 72.1601 51.0855 71.8386 51.0855 74.0709Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9145 74.0709C78.9145 76.3033 80.2266 78.4804 82.5843 78.4804C84.942 78.4804 87 77.2587 87 75.0263C87.0027 73.0074 84.917 72.4118 82.5562 72.1601C80.1985 72.1601 78.9145 71.8386 78.9145 74.0709Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5698 76.7787C53.471 76.408 51.4633 77.7771 51.0855 79.8367L48.5 93H56.5L58.6862 81.1791C59.0639 79.1195 57.6687 77.1494 55.5698 76.7787Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9474 76.7787C76.0462 76.408 78.0539 77.7771 78.4317 79.8367L81 93H73.2198L70.8311 81.1791C70.4533 79.1195 71.8485 77.1494 73.9474 76.7787Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7815 54.7692C55.6445 54.7692 57.3745 55.0038 48.5296 70.6735C50.0274 70.7469 52.7819 70.6609 52.3625 74.0709C53.4859 73.14 57.4704 64.7279 57.4704 64.7279C58.5938 64.2869 57.6666 70.4963 57.4419 71.7457L56.1934 74.0709C57.3668 74.0709 58.3217 74.0709 60.0244 74.0709H65.1323H71.5319C72.3685 74.0709 72.3685 74.0709 73.2198 74.0709L72.0462 71.8192C71.8215 70.5698 70.8194 64.2869 71.9428 64.7279C71.9428 64.7279 76.353 73.14 77.4764 74.0709C77.057 70.6609 79.3858 70.7469 80.8836 70.6735C72.0387 55.0038 73.9185 54.7692 64.7815 54.7692Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1598_59",
    x: 30,
    y: 34,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_59"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_59",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatWithHuman);
export default __webpack_public_path__ + "static/media/seatWithHuman.da1e59473ed576251cb90badcb37a4cd.svg";
export { ForwardRef as ReactComponent };